define.alias("shared/components/shared/credentials/upgrade-button", "calendar/components/shared/credentials/upgrade-button");